<div ng-controller="moviesListController as ctrl" class="help-movie-list">
    <div ng-if="ctrl.movies.length == 0" class="list-item end-of-list">
        <div><h3>{{ctrl.noItems}}</h3></div>
        <div class="end-image" ng-bind-html="ctrl.endImage"></div>
    </div>
    <div ng-repeat="movie in ctrl.movies" class="help-movie-list-item">
        <h1>{{movie.title}}</h1>
        <p ng-if="movie.description">{{movie.description}}</p>
        <p>{{'help.for'|translate}} {{ctrl.targetAudience(movie.target)}}</p>
        <iframe width="640" height="360" ng-src="{{ctrl.youtubeUrl(movie.youtubeId)}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
</div>